import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37e75d3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "conservation-area"
}
const _hoisted_2 = { class: "conservation-area__title h4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "conservation-area-info__icon icon icon-tooltip-black" }, null, -1))
const _hoisted_4 = { class: "conservation-area-info__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "continue-button__icon icon icon-arrow-right" }, null, -1))
const _hoisted_6 = { class: "conservation-area-modal__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Article = _resolveComponent("Article")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createVNode(_component_RadioGroup, {
          modelValue: _ctx.isInConservationArea,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isInConservationArea) = $event)),
          options: _ctx.options
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("a", {
          class: "conservation-area-info",
          href: "javascript:;",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
        }, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pageContent.moreInfoCopy), 1)
        ]),
        _createVNode(_component_AppButton, {
          disabled: _ctx.isInConservationArea === null,
          class: "conservation-area__next-button",
          "full-width": "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('go-forward')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.continueButtonCopy), 1),
            _hoisted_5
          ], undefined, true),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Modal, {
          class: "conservation-area-modal",
          "is-modal-open": _ctx.isModalOpen,
          onCloseModal: _ctx.toggleModal
        }, {
          header: _withCtx(() => [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.pageContent.moreInfoModalTitle), 1)
          ]),
          body: _withCtx(() => [
            _createVNode(_component_Article, {
              class: "conservation-area-modal__copy",
              "text-content": _ctx.pageContent.moreInfoModalCopy,
              "no-margin": ""
            }, null, 8, ["text-content"])
          ]),
          cancelButton: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.pageContent.moreInfoModalCloseButtonCopy), 1)
          ]),
          _: 1
        }, 8, ["is-modal-open", "onCloseModal"])
      ]))
    : _createCommentVNode("", true)
}